import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { restoreSZLTFailed, restoreSZLTSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* restoreSZLT(action) {
  try {
    const url = `${BACKEND_URL}/registries/order-services/${action.payload}/restore`;
    const dataResponse = yield makeRequest(url, {}, action, 'POST', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(restoreSZLTSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(restoreSZLTFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(restoreSZLTFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
